import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAI, VertexAIBackend } from 'firebase/ai';

const firebaseConfig = {
    apiKey: "AIzaSyBwwgSq-3CMrO3eHoObKqhDwAU6SB4cFfw",
    authDomain: "govtai.firebaseapp.com",
    projectId: "govtai",
    storageBucket: "govtai.firebasestorage.app",
    messagingSenderId: "754718045654",
    appId: "1:754718045654:web:72ad6800c344fd67d76077",
    measurementId: "G-QSKW5QC5DM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Emulator Configuration (Standardized to 3000 range)
// NOTE: Temporarily disabled because local system lacks Java to run emulators.
/*
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    console.log("🛠️ Dev Environment: Connecting to Local Emulators (Port 3001+)");
    connectFunctionsEmulator(functions, 'localhost', 3001);
    connectFirestoreEmulator(db, 'localhost', 3002);
    connectAuthEmulator(auth, 'http://localhost:3003', { disableWarnings: true });
}
*/

export const vertexAI = getAI(app, {
    backend: new VertexAIBackend('us-central1')
});

export default app;
